import React, { useState } from 'react';
import { SendIcon, CheckCircleIcon } from 'lucide-react';
export function WaitlistSection() {
  const [email, setEmail] = useState('');
  const [isMerchant, setIsMerchant] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsLoading(true);
      // Simulate API call
      setTimeout(() => {
        setIsLoading(false);
        setSubmitted(true);
      }, 1500);
    }
  };
  // Return empty fragment instead of the waitlist section
  return <></>;
}